import {atom} from 'recoil'

export const widgetCategoryIndexState = atom<number>({
    key: "widgetCategoryIndexState",
    default: 0
})